import React from 'react';
import './ContactsModalUrgent.scss'
import moment from 'moment';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const ContactItem = ({ contact, dismiss, markAsUpdated }) => {
  const [t] = useTranslation();
  const { id, first_name = '', last_name = '', company_name, updated_at, email, phone } = contact || {}

  return (
    <div className="cont-grey">
      <div className="cont-grey-header">
        <div className="row">
          <div className="col-6">
            <h6>
              <i className="fas fa-user"></i> {first_name} {last_name}
            </h6>
          </div>
          <div className="col-6 text-right">
            <h6>{t('COMMON:LAST_UPDATE')}: {moment(updated_at).format('D MMMM YYYY')}</h6>
          </div>
        </div>
      </div>
      <div className="cont-grey-body">
        <p className="contact-info">
          {company_name && <><strong>{t('COMMON:COMPANY')}:</strong> {company_name}<br/></>}
          {email && <><strong>{t('COMMON:EMAIL')}:</strong> {email}<br/></>}
          {phone && <><strong>{t('COMMON:PHONE')}:</strong> {phone}</>}
        </p>
      </div>
      <div className="cont-todo-buttons">
        <Button onClick={() => dismiss(id)} className="dismiss"><i className="fas fa-times"></i> {t("COMMON:DISMISS")}</Button>
        <Button onClick={() => markAsUpdated(id)} className="done"><i className="fas fa-check"></i> {t("COMMON:DONE")}</Button>
      </div>
    </div>
  );
};

export default ContactItem;
